import { OperationType } from '@helpers/Enums';
import I18n from '@src/i18n';
import { Select } from 'antd';
import React, { Component } from 'react';

import { ConditionFooterWrapper, GhostButton } from './WorkflowConditionsModalStyles';

const trash = require('../workflowAssets/trash.svg')

interface PropType {
  delete: boolean;
  deleteCondition: Function;
  operation?: number;
  handleOperation: Function;
  currentConditionNexts: any;
  setConditionNext: Function;
  condition: any;
}

interface StateType {

}

export default class  ConditionFooter extends Component<PropType, StateType> {
  constructor(props: PropType){
    super(props)
  }
  render() {
    const { Option } = Select
    const { operation, handleOperation, currentConditionNexts, setConditionNext, condition } = this.props

    return (
      <ConditionFooterWrapper>
        <div className="wrapper-content">
          <span className="label">{I18n.l('common.if')}</span>
          <Select onChange={handleOperation} value={operation} id="and/or-selector" className="long erase-transform">
            <Option value={OperationType.AND}>{I18n.l('workflow.conditions.and')}</Option>
            <Option value={OperationType.OR}>{I18n.l('workflow.conditions.or')}</Option>
          </Select>
          <span className="label" style={{marginLeft: '2%'}}>{I18n.l('formflow.labels.nextSectionSelect')}</span>
          <Select value={condition.next} onChange={setConditionNext} id="go-to-component-select">
            {currentConditionNexts.map((next: any) => <Option key={`${next.id}-footer`} value={next.id}>{next.title}</Option>)}
          </Select>
          
          {this.props.delete && 
          <div onClick={this.props.deleteCondition} className="delete-container margin-left">
            <img className="delete-icon" src={trash} />
            <GhostButton color="#D93838" className="delete">{I18n.l('common.delete')}  {(I18n.l('formflow.labels.condition').toLowerCase())}</GhostButton>
          </div>}

        </div>
      </ConditionFooterWrapper>
    )
  }
}
